import { LoanApplication } from '@sageworks/jpi';

const finalStatusesWithBorrowerSubmission = [
	LoanApplication.ApplicationStatusEnum.ReadyForBorrowerSubmission,
	LoanApplication.ApplicationStatusEnum.ApplicationComplete,
	LoanApplication.ApplicationStatusEnum.Approved,
	LoanApplication.ApplicationStatusEnum.Declined,
	LoanApplication.ApplicationStatusEnum.Withdrawn,
	LoanApplication.ApplicationStatusEnum.Locked
];
const finalStatuses = [
	LoanApplication.ApplicationStatusEnum.ApplicationComplete,
	LoanApplication.ApplicationStatusEnum.Approved,
	LoanApplication.ApplicationStatusEnum.Declined,
	LoanApplication.ApplicationStatusEnum.Withdrawn,
	LoanApplication.ApplicationStatusEnum.Locked
];

export function isInFinalStatus(status: LoanApplication.ApplicationStatusEnum, canSubmitForBorrower: boolean) {
	if (canSubmitForBorrower) {
		return finalStatusesWithBorrowerSubmission.includes(status);
	}
	return finalStatuses.includes(status);
}
